import styled from 'styled-components';
import { TimePicker } from '../../DatePicker';

export const Row = styled.div`
  display: flex;
`;

export const Column = styled(Row)`
  flex-direction: column;
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
`;

export const FlexRow = styled(Row)`
  flex-wrap: wrap;
  column-gap: 4px;
  margin-bottom: 12px;
`;

export const StyledLabel = styled.div`
  font-size: 12px;
  margin: 0 0 12px 0;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
  &:last-child {
    margin-bottom: 0;
    margin-top: auto;
    padding-bottom: 24px;
  }
`;

export const ExecutionTimeDropdown = styled(TimePicker)`
  && {
    width: 160px;
    max-width: 100%;
  }
`;
